export default __webpack_public_path__ + "static/media/speak_rus_fav.ec40e6c0.png";